module.exports = __webpack_public_path__ + "img/Recurso 1.ff9fc693.png";